import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as theGlobals from '../shared/globals';
import { EmailDto} from '../shared/dto/email.dto';

@Injectable()

export class EmailService {

    private myUrl = theGlobals.setEnv().funcUrl;

    constructor(private http: HttpClient) {
    }

    sendEmail(emailType: string, emailMsg: EmailDto): Observable<any>
    {
      const xUrl = this.myUrl + '/emailerG/' + emailType;
      return this.http.post(xUrl, emailMsg);
    }
}
